import apiClient from './apiClient';

export function listMessageThreads({ shopId } = {}) {
  return apiClient.get('/message_threads', {
    query: shopId ? { shop_id: shopId } : undefined,
    suppressError: true,
  });
}

export function getMessageThread(threadId, { shopId } = {}) {
  return apiClient.get(`/message_threads/${threadId}`, {
    query: shopId ? { shop_id: shopId } : undefined,
    suppressError: true,
  });
}

export function createMessageThread(payload) {
  return apiClient.post('/message_threads', payload, { suppressError: true });
}

export function sendThreadMessage(threadId, payload) {
  return apiClient.post(`/message_threads/${threadId}/messages`, payload, { suppressError: true });
}

export function updateThreadMessage(threadId, messageId, payload) {
  return apiClient.patch(`/message_threads/${threadId}/messages/${messageId}`, payload, {
    suppressError: true,
  });
}

export function deleteThreadMessage(threadId, messageId, payload = {}) {
  return apiClient.delete(`/message_threads/${threadId}/messages/${messageId}`, {
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    suppressError: true,
  });
}

export function markThreadRead(threadId, payload = {}) {
  return apiClient.post(`/message_threads/${threadId}/mark_read`, payload, { suppressError: true });
}

export function getUnreadMessageSummary({ shopId } = {}) {
  return apiClient.get('/message_threads/unread_summary', {
    query: shopId ? { shop_id: shopId } : undefined,
    suppressError: true,
  });
}

export function searchMessageStocks(shopId, query) {
  return apiClient.get('/stocks', {
    query: {
      shop_id: shopId,
      q: query || undefined,
      page_size: 24,
    },
    suppressError: true,
  });
}
